import { ParentCommentSync } from '../components/ParentCommentSync'

/**
 * 連絡帳同期ページ
 */
export function ParentCommentSyncPage() {
  return <ParentCommentSync />
}
